export enum ActionType {
  RequestCompleteProfile = 'request_complete_profile',
  NavigateTo = 'navigate_to',
}

export interface ActionCompleteProfile {
  type: ActionType.RequestCompleteProfile;
  payload?: {
    return_url?: string; // Removed support of return_url
  };
}

export interface ActionNavigateTo {
  type: ActionType.NavigateTo;
  payload: {
    url: string;
    openURLInWebView?: boolean;
  };
}

export type DynamicCardAction = ActionCompleteProfile | ActionNavigateTo;
